import React from "react";
import { money, precioDe, zonaVendible } from "./boleteraHelper";

/*
  Zonas destino del tramo, cada una con su color. Se elige la zona, no la parada: el
  precio solo depende de la zona.
  Una zona sin tarifa para el origen elegido se muestra deshabilitada y explica por qué:
  bloquear la venta es preferible a cobrar un precio inventado.
*/
const ZonaGrid = ({ catalogo, zonaOrigenId, seleccion, onPick }) => {
  const zonas = catalogo?.zonas ?? [];

  if (!zonas.length) {
    return (
      <div className="text-center text-muted py-4" style={{ fontSize: "12.5px" }}>
        Ninguna parada de este tramo del ramal tiene zona asignada, así que no hay destinos
        que cobrar. Pide a tu analista que asigne las zonas en las geocercas del ramal.
      </div>
    );
  }

  return (
    <div>
      {zonas.map((zona) => {
        const vendible = zonaVendible(catalogo, zona, zonaOrigenId);
        const elegida = seleccion?.id === zona.id;
        const desde = (catalogo.tipos ?? [])
          .map((t) => precioDe(catalogo, zona, t, zonaOrigenId))
          .filter((p) => p != null);

        return (
          <button
            key={zona.id}
            type="button"
            className={`boletera-zona${elegida ? " is-selected" : ""}`}
            style={{ borderColor: elegida ? zona.color : undefined }}
            disabled={!vendible}
            title={vendible ? zona.nombre : "Sin tarifa configurada para este trayecto"}
            onClick={() => onPick(zona)}
          >
            <div className="boletera-zona-head">
              <span className="boletera-zona-dot" style={{ background: zona.color }} />
              <span style={{ fontWeight: 600, fontSize: "13.5px" }}>{zona.nombre}</span>
              <span style={{ flex: 1 }} />
              <span style={{ fontSize: "11.5px", color: "#777a89" }}>
                {vendible ? `desde ${money(Math.min(...desde))}` : "sin tarifa"}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default ZonaGrid;
